import {useCallback, useEffect, useState, useRef} from 'react'
import Table from "../Components/Table/Table";
import {Link} from "react-router-dom";
import {Api} from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import Popup from "../Components/PopUp/Popup";
import SearchUI from '../Search/SearchUI';
import ExportMetaData from '../Main/ExportMetaData/ExportMetaData'
import DeleteModal from '../Components/Deletemodal/DeleteModal';

const Reportconfig = {   
    url: "reports",
    name: "Report",
    columns: [
        { name: "Name", accessor:(object)=>{
           return object.template.name;
        } },
        { name: "Type",accessor:(object)=>{
            return object.eventWith;
        }},
        { name: "Verified",accessor:(object)=>{
            if(object.Verified){
                return "Verified";
            }
            else{
                return "Not verified";
            }
        }},
        { name: "Download",accessor:(object)=>{
            if(object["eventWith"] == "IIC"){
                let links = `/iicreport/${object.id}`;
                if(object.newIic){
                    links = `/newIicReport/${object.id}`;
                }
               return <Link to={links} >Download Report</Link>;
            }
            else if(object["eventWith"] == "RISE-Event"){
               let links = `/riseEventReport/${object.id}`;
               return <Link to={links} >Download Report</Link>;
            }
            else{
               let links = `/eventreport/${object.id}`;
               return <Link to={links} >Download Report</Link>;
            }
           
        }},
        {
            name: "Brochure", accessor: (object) => {
                return object?.template?.Poster ? <a href={object.template.Poster} target="_blank">Brochure</a> : "-";
            }
        },
        {
            name: "Feedback", accessor: (object) => {
                return object?.feedback ? <a href={object.feedback} target="_blank">Feedback</a> : "-";
            }
        },
        {
            name: "Expenditure", accessor: (object) => {
                return object?.expenditure ? <a href={object.expenditure} target="_blank">Expenditure</a> : "-";
            }
        },
        { name: "Attendence",accessor:(object)=>{
            if(object["Attendence"]){
               let links = object["Attendence"];
               return <Link  target="_blank" to={links} >Attendence</Link>;
            }
            else{
               let links ="#";
               return <Link to={links} >-</Link>;
            }
           
        }},
        { name: "Actions", key: "actions" },
    ]
}

const TemplateReports = ({user, ...props}) => {
    const params = useParams();
    const {id} = params;
    let tableRef = new Table();
    const navigate = useNavigate();
    const [ del, setDel ] = useState(false);
    const [ did, setDId ] = useState();
    const config = Reportconfig;
    const [ state, setState ] = useState({
        loading: false,
        error: null,
        config: config,
        page: 1,
        limit: 10,
        total: 0,
        show: false,
        search:true,
        showSearch:false
    });
    
    const [filter,setFilter] = useState(null);
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState(-1); 
    const [iicName, setIicName] = useState("IIC");   

    const loadData = useCallback(() => {
        Api.call(`/getReportbyUser?template=${params.id}`)
        .then((data)=>{
            setPosts(data);
        }).catch((e)=>{
            console.log(e);
        }).finally(()=>{
            setState(s => {
                return {...s, loading: false}
            });
        })
    }, [config.url, state.page, state.limit,iicName]);

    const onPaginate = (page) => {
        setState({...state, page: page, loading: true})
    };

    useEffect(() => {
        if (!user) {
            return;
        }
        loadData()
    }, [loadData, params.path, user,params.id]);

    const parsePatient = (post) => {
        let row = state.config.columns.map((column) => {
            if (column.accessor) {
                return column.accessor(post);
            }
            return post[column.key];
        });
        return row;
    };

    const renderRow = (row, index) => {
        let columnIndex = 0;
        let patient = parsePatient(row);
        return <tr key={index}>
            <td key={index}>{`${(state.page - 1) * state.limit+(index+1)}`}</td>
            {patient.map(column => {
                return renderColumn(column, columnIndex++, index, patient, row);
            })}</tr>
    };

    const selectAll = () => {
        let allSelected = !state.allSelected;
        let row = state.row.map(patient => {
            patient.selected = allSelected;
            return patient;
        });
        setState({...state, row: row, allSelected: allSelected});
    };

    const onDelete = (event, index) => {
        setState(s => {
            return {...s, loading: true}
        });
        event.preventDefault();
        let post = posts[index];
        setDel(false);
        Api.call(`/${config.url}/${post.id}`, "DELETE").then(response => {
            loadData();
        })
    };

    const onUp = (event, index) => {
        event.preventDefault();
        setState({...state, loading: true})
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/up`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const onDown = (event, index) => {
        setState({...state, loading: true})
        event.preventDefault();

        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/down`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const showSearchbox = (boolean) =>{
        setState(s =>{
           return { ...s, showSearch:boolean }
        })
    }

    const filterBuilder = (query) =>{
        setFilter(query); 
    }

    const renderColumn = (column, index, rowIndex, row, originalRow) => {
        if (index === row.length - 1) {
            if (state.config.renderActions) {
                return state.config.renderActions(column, index, rowIndex, row, originalRow, onUp , onDown,onDelete, state, config);
            }
            else {
                return <td key={index}>
                <ul>
                    <li>                          
                        {originalRow?.newIic === true ? 
                            <Link to={`/Report/${originalRow.id}/${params.id}/New-IIC`}>
                                {columnConfig.editIcon}
                            </Link>
                        : <Link to={`/Report/${originalRow.id}/${params.id}`}>
                                {columnConfig.editIcon}
                            </Link>}
                    </li>
                    <li>
                        {/* e => onDelete(e, rowIndex) */}
                        <Link to="" onClick={()=>{setDel(true); setDId(rowIndex)}}>
                           {columnConfig.deleteIcon}
                        </Link>
                    </li>
                </ul>
            </td>
        }
        }
        if (typeof column === "boolean") {
            return <td key={index}><span style={{color: column ? "green" : "red"}}>{column ? "Yes" : "No"}</span></td>
        }
        // console.log("Rendering ", column)
        return <td key={index}>{column}</td>
    };
    const renderHeaderColumn = (column, index) => {

        return (
            <th key={index}>
                {column.name}
            </th>
        );
    };

    const onclick = () =>{
        tableRef.export(ExportMetaData.PastEvent,posts)
    }

    // if(state.loading === false && posts.length === 0)
    // {
    //     return (
    //         <div className="right_container">
    //             <div className="dashboard">
    //                 <div className='inner-content'>
    //                     <div className="heading-for-certificate">
    //                         <h2>{`Events`}</h2>
    //                         <p>
    //                             There are no events created yet.
    //                             Start adding events by clicking on add new event. 
    //                         </p>
    //                         <ul>
    
    //                             <li>
    //                                 <Link to={`/${config.url}/new`}>
    //                                     <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
    //                                     Add New
    //                                 </Link>
    //                             </li> 
    //                         </ul>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }
    return (
        <div className="right_container">
            <Popup trigger={del} icon='../../../../images/delete-icon.svg' actionParams={did} action={onDelete} class="delete-popup" setSearch={setDel}>
               <DeleteModal/>
            </Popup>
            <div className="dashboard">
                <div className='inner-content'>

                    <Heading name={config.name} refreshlink="#" url={params.path} total={total} 
                    arrayLink={[`/Report/new/${params.id}/New-IIC`,`/Report/new/${params.id}/${iicName}`,`/Report/new/${params.id}/RISE-Event`,`/Report/new/${params.id}/Common`]}
                    arrayName={["Add-IIC(from 01/July/2026)","Add-IIC(Till 30/June/2026)","Add-Rise","Add-Common"]} certificate={params.id} navigate={navigate} />
                    
                    <div className='commen-table'>
                        <Table serial={true} ref={tableRef} renderColumn={renderColumn}  loading={state.loading}
                            renderRow={renderRow} renderHeaderColumn={renderHeaderColumn} 
                            columns={state.config.columns} cardFooter="cardFooter" total={total}     
                            currentPage={state.page} perPage={state.limit} filter={localStorage.getItem("data") ? {"query":true} : filter}
                            rows={posts} selected="Invite Selected" onPaginate={onPaginate}
                            onChangePerPage={(limit) => {
                            setState({...state, limit});
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({type: 'LOGIN', data: user})
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateReports)
